export default __webpack_public_path__ + "static/media/N 핸디노트 - 라이트블루.0a795fad.png";